// @material-ui/icons
import Settlement from "@material-ui/icons/Style";
import AirlineRouteIcon from "@material-ui/icons/Flight";
import Reconciliation from "@material-ui/icons/RestorePage";
import Audit from "@material-ui/icons/TrackChanges";
import Landing from "@material-ui/icons/FlightLandOutlined";

import MainLandingPage from "../layouts/Landing/RegionalLanding/landing";

import SettlementPage from "Regional-Views/Settlement/Index.jsx";
import NotFound from "Regional-Views/NotFound/Index.jsx";
import StatementOfAccount from "Regional-Views/StatementOfAccount/Index.jsx"
import Audits from "Regional-Views/AuditTrail/Index.jsx";
import ExchangeRateAirlineView from "Regional-Views/ExchangeRateAirline/airlineView.js";
import HelpCenter from "../Regional-Views/HelpCenter/index"
import HelpIcon from "@material-ui/icons/HelpOutline"

const dashboardRoutes = [
  {
    path: "/main-landing",
    sidebarName: "Main Landing",
    navbarName: "Main Landing",
    icon: Landing,
    component: MainLandingPage,
    subMenu: [],
  },
  {
    path: "/app/psc-regional/psc-settlement",
    sidebarName: " PSC Settlement",
    navbarName: "PSC Settlement",
    icon: Settlement,
    subMenu: [],
    component: SettlementPage
  },
  {
    path: "/app/psc-regional/statement-of-account",
    sidebarName: "Account Statement",
    navbarName: "Account Statement",
    icon: Reconciliation,
    component: StatementOfAccount,
    subMenu: []
  },
  {
    path: "/app/psc-regional/audits",
    sidebarName: "Audit Trail",
    navbarName: "Audit Trail",
    icon: Audit,
    subMenu: [],
    component: Audits,
  },
  {
    path: "/app/psc-regional/exchange-rate",
    sidebarName: "Exchange Rate",
    navbarName: "Exchange Rate",
    icon: AirlineRouteIcon,
    subMenu: [],
    component: ExchangeRateAirlineView,
  },
  {
    path: "/app/psc-regional/help-center",
    sidebarName: "Help Center",
    navbarName: "Help Center",
    icon: HelpIcon,
    component: HelpCenter,
    subMenu: []
  },
  {
    isNotVisible: true,
    path: "**",
    sidebarName: "Not found",
    navbarName: "Not Found",
    icon: Audit,
    subMenu: [],
    component: NotFound,
    
  }
];

export default dashboardRoutes;



// WEBPACK FOOTER //
// ./src/routes/regional-audit.jsx